export class Cargo {
  idCargo: number = 0
  descricao?: string = ""
  atribuicoes?: string = ""
  escolaridade?: string = ""
  experiencia?: string = ""
  qualificacoes?: string = ""
  ativo?: boolean = true
}

export interface CargoResume {
  idCargo: number
  descricao?: string
}